import React from 'react';

import { TEXTS } from 'application/pages/texts';
import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import styles from './index.module.scss';

export type CustomContentBindCardModalProps = {
  isLoading: boolean;
  onSubmit: () => void;
  onCancel: () => void;
};

const CustomContentBindCardModal = ({ isLoading, onSubmit, onCancel }: CustomContentBindCardModalProps) => (
  <ModalScreen
    title={TEXTS.CUSTOM_CONTENT_BIND_CARD_MODAL_TITLE}
    hideCloseButton
    onClose={onCancel}
    actionButtons={[
      <Button
        key="button_remove_custom_content_submit"
        elementId="button_remove_custom_content_submit"
        isLoading={isLoading}
        type={ButtonType.PRIMARY}
        onClick={onSubmit}>
        {TEXTS.CUSTOM_CONTENT_BIND_CARD_MODAL_BUTTON_SUBMIT}
      </Button>,
      <Button
        key="button_remove_custom_content_cancel"
        elementId="button_remove_custom_content_cancel"
        isLoading={isLoading}
        type={ButtonType.SECONDARY}
        onClick={onCancel}>
        {TEXTS.CUSTOM_CONTENT_BIND_CARD_MODAL_BUTTON_CANCEL}
      </Button>,
    ]}>
    <span className={styles.CustomContentBindCardModalDesc}>{TEXTS.CUSTOM_CONTENT_BIND_CARD_MODAL_DESC}</span>
  </ModalScreen>
);

export default CustomContentBindCardModal;
